import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map, mergeMap, tap } from 'rxjs/operators'
import { ConfigService } from '../../../../config/config.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'

@Injectable({
  providedIn: 'root'
})
export class StatsService {

  data: any = []
  active = ''
  /**
   * @param {HttpClient} http
   * @param {ConfigService} configService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private clientService: ClientService
  ) {
  }

  /**
   *
   * @param {Client} client
   * @returns {Observable<Object>}
   */
  getStock(client: Client, filterType: string, filterContent: string): Observable<Array<Object>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Object>>(config.apiPoint + config.stockClientStats.replace('{client}', client.id), {
          params: {
            filterType: filterType,
            filterContent: filterContent
          }
        })
      })
    )
  }

  /**
   *
   * @param {Client} client
   * @param filterType
   * @param filterContent
   * @returns {Observable<Object>}
   */
  getPorteurs(client: Client, filterType: string, filterContent: string): Observable<Array<Object>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Object>>(config.apiPoint + config.cabClientStats.replace('{client}', client.id), {
          params: {
            filterType: filterType,
            filterContent: filterContent
          }
        })
      })
    )
  }

  /**
   *
   * @param {Client} client
   * @returns {Observable<Object>}
   */
  getRotations(client: Client): Observable<Array<Object>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Object>>(config.apiPoint + config.rotationClientStats.replace('{client}', client.id)).pipe(
          map(data => {
            for (const key in data) {
              data[key]['qt_theo'] = data[key]['qt_theo'] != '' ? data[key]['qt_theo'] : '0'
              return data
            }
          })
        )
      })
    )
  }

  getCabDBIntegrity(client: Client, filterType: string, filterContent: string): Observable<Array<Object>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Object>>(config.apiPoint + config.getCabDBIntegrityStats.replace('{client}', client.id), {
          params: {
            filterType: filterType,
            filterContent: filterContent
          }
        })
      })
    )
  }

  getConsoHistory(client: Client): Observable<Array<Object>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Object>>(config.apiPoint + config.getConsoHistoryStats.replace('{client}', client.id)).pipe(
          map(data => {
            return data
          })
        )
      })
    )
  }

  getLastCleaning(client: Client, filterType: string, filterContent: string): Observable<Array<Object>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Object>>(config.apiPoint + config.getLastCleagingStats.replace('{client}', client.id), {
          params: {
            filterType: filterType,
            filterContent: filterContent
          }
        })
      })
    )
  }

  exportOfCurrentClient(active, type, param) {
    return this.export(this.clientService.currentClient$.getValue(), active, type, param)
  }

  downloadStatsOfClient(active, type) {
    return this.downloadStats(this.clientService.currentClient$.getValue(), active, type)
  }

  private export(client: Client, active, type, param) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.exportClientStats.replace('{client}', client.id).replace('{export}', type).replace('{type}', active), { responseType: 'arraybuffer', params: param }).pipe(
          tap(res => {
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
            const nav = (window.navigator as any)
            if (nav.msSaveOrOpenBlob) {
              const newUrl = nav.msSaveOrOpenBlob(blob, `export_${active}.xlsx`)
            } else {
              const link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.setAttribute('download', `export_${active}.xlsx`)
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }
          }))
      }))
  }

  private downloadStats(client: Client, active, type) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<string>(config.apiPoint + config.getClientDownloadStats.replace('{client}', client.id).replace('{type}', type), {
        })
      })
    )
  }

  exportAll(user: number, active) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.exportClientAllStats.replace('{type}', active), { responseType: 'arraybuffer' }).pipe(tap(res => {
          const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
          const nav = (window.navigator as any)
          if (nav.msSaveOrOpenBlob) {
            const newUrl = nav.msSaveOrOpenBlob(blob, `export_${active}.xlsx`)
          } else {
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', `export_${active}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }))
      }))
  }

  getStatsLingeHebergement(client, filter): Observable<any[]> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<any[]>(config.apiPoint + config.getClientStatsLingeHebergement.replace("{client}", client.id), {
          params: filter
        })
      })
    )
  }

  getStatsLHDispatch(client, filter): Observable<any[]> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<any[]>(config.apiPoint + config.getClientStatsLHDispatch.replace("{client}", client.id), {
          params: filter
        })
      })
    )
  }

  exportLingeHebergementOfCurrentClient(filter) {
    return this.exportLingeHebergement(this.clientService.currentClient$.getValue(), filter)
  }

  private exportLingeHebergement(client: Client, filter) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.exportLingeHebergementStats.replace('{client}', client.id), { responseType: 'arraybuffer', params: filter }).pipe(
          tap(res => {
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', `export_linge-hebergement.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }))
      }))
  }
}
